import { FieldValidator } from '../../models/FieldValidator.model';
import { ValidationRules } from '../../models/ValidationRuleNames.model';

import { createValidDateValidator } from './validateDate.validator';

export function createDateValidators(
    fieldName: string, customMessages?: Record<ValidationRules, string>,
): FieldValidator[] {
    const validators: FieldValidator[] = [];
    // hardcoding the format to M/D/YYYY because we are not defining a format in the type definition yet
    validators.push({
        name: 'date.validDate',
        validate: createValidDateValidator(
            // this is to support mixed of month or day padded vs unpadded formats
            [ 'M/D/YYYY', 'M/DD/YYYY', 'MM/D/YYYY', 'MM/DD/YYYY' ],
            { fieldName, customMsg: customMessages?.['date.validDate'] },
        ),
    });
    return validators;
}
